// Tracks "this real backend id was just an optimistic id a moment ago", so a
// consumer keyed by `scene.id` can migrate its state from the old key to the new
// one instead of treating the renamed scene as a brand-new one (for a per-scene
// parse cache, a fresh key reassigns lineIds and remounts every line, losing
// focus and in-flight typing).
//
// `optimisticHelpers`'s `onSuccess` writes the alias just before replacing the
// entity in the React Query cache; `consumeOptimisticIdAlias` deletes it on read.
// Nothing reads it today (the editor engine re-keys a created scene through its own
// `aliasScene` command, dispatched by `useSceneCreation`), so entries are never deleted.

const aliases = new Map<number, number>(); // realId → optimisticId

export function recordOptimisticIdAlias(realId: number, optimisticId: number): void {
    aliases.set(realId, optimisticId);
}

export function consumeOptimisticIdAlias(realId: number): number | undefined {
    const optimisticId = aliases.get(realId);
    if (optimisticId !== undefined) aliases.delete(realId);
    return optimisticId;
}

export function peekOptimisticIdAlias(realId: number): number | undefined {
    return aliases.get(realId);
}
